// @ts-strict-ignore
import { FC } from 'react'

import { Switch } from '@/shared/ui/switch'

import cls from './switch-filter.module.scss'

interface SwitchFilterProps {
	name: string
	label: string
	checked: boolean
	isDisabled?: boolean
}

export const SwitchFilter: FC<SwitchFilterProps> = ({ name, label, checked, isDisabled }) => (
	<div className={cls.root}>
		<p className={cls.title}>{label}</p>

		<Switch name={name} disabled={isDisabled} defaultChecked={checked} checked={checked} />
	</div>
)
